import { combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux'
import auth from './auth'
import invoice from './invoice'
import credit from './credit'

export default combineReducers({
  routing: routerReducer,
  auth,
  invoice,
  credit
})


// WEBPACK FOOTER //
// ./src/reducers/index.js